import { types as auth } from "../actions/auth";
import { types as account } from "../actions/account";
import { types as tokens } from "../actions/tokens";

const initialState = {
  loggedIn: false,
  loaded: false,
  tokens: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case auth.OK:
      return {
        ...state,
        loading: false,
        loaded: true,
        loggedIn: true,
        // user
        // role: state.user.user_roles.filter(v => v.site_id === action.result.id).shift()
        account: action.data.account,
      };

    case auth.LOGIN_PENDING:
      return { ...state, loading: true };

    case auth.LOGIN:
      return { ...state, loading: false };

    case auth.FAIL:
      return {
        ...state,
        loggedIn: false,
        loading: false,
        loaded: true,
        error: action.error,
      };

    case account.SAVE:
      return { ...state, account: action.data.account };

    case account.LOAD_TOKENS:
      return { ...state, tokens: action.data };

    case tokens.DELETE:
      const index = state.tokens.findIndex(
        (token) => token.id === action.data.id
      );
      if (index < 0) return state;
      return {
        ...state,
        tokens: [
          ...state.tokens.slice(0, index),
          ...state.tokens.slice(index + 1),
        ],
      };

    case auth.LOGOUT:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/auth.js